import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/settings/workspace/page';

export const Route = createFileRoute('/_app/settings/workspace/')({
  component: Page,
});
